<script setup lang="ts">
import { resolveGpoChip } from '~/utils/resolveGpoChip'
import type { GpoChipClinicChain } from '~/utils/resolveGpoChip'

interface Props {
  clinicChain?: GpoChipClinicChain | null
  size?: 'x-small' | 'small' | 'default'
  dataNavId?: string
}

const props = withDefaults(defineProps<Props>(), {
  clinicChain: null,
  size: 'small',
  dataNavId: 'product_clinic_chain',
})

const localePath = useLocalePath()
const chip = computed(() => resolveGpoChip(props.clinicChain))
</script>

<template>
  <v-chip
    v-if="chip.show"
    :to="localePath('/clinic-chain')"
    :data-nav-id="dataNavId"
    :size="size"
    tag="nuxt-link"
    class="mt-1"
    :variant="chip.variant"
    :color="chip.color"
    :class="chip.logoSrc ? 'text-white' : undefined"
    data-test-id="gpo-buying-list-chip"
  >
    <img
      v-if="chip.logoSrc"
      :src="chip.logoSrc"
      :alt="props.clinicChain?.name"
      class="gpo-buying-list-chip__logo mr-1"
    >
    <span v-if="chip.showName">{{ props.clinicChain?.name }}</span>
    <span
      v-if="chip.labelKey"
      :class="chip.showName ? 'ml-1' : undefined"
    >{{ $t(chip.labelKey) }}</span>
  </v-chip>
</template>

<style scoped lang="scss">
.gpo-buying-list-chip__logo {
  height: 14px;
  width: auto;
  filter: brightness(0) invert(1);
  -webkit-filter: brightness(0) invert(1);
  -moz-filter: brightness(0) invert(1);
  -ms-filter: brightness(0) invert(1);
  -o-filter: brightness(0) invert(1);
}
</style>
